import { api } from "./client";

export interface WipeResult {
  detail: string;
  deleted: Record<string, number>;
}

export const maintenanceApi = {
  wipeEmployees: () => api.post<WipeResult>("/system/wipe/employees/").then((r) => r.data),
  wipeInventory: () => api.post<WipeResult>("/system/wipe/inventory/").then((r) => r.data),
};
